import { render, staticRenderFns } from "./BuyHistory.vue?vue&type=template&id=7527503a&"
import script from "./BuyHistory.vue?vue&type=script&lang=js&"
export * from "./BuyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports